import {ApiRoute} from '~/constants/api';
import axiosInstance from '~/services/api/axios';

export interface ProcessPaymentLinkRequest {
  payment: {
    payment_method_id?: string;
    provider: string;
    amount: number;
    description: string;
    appointment_id?: string;
    payment_id?: string;
  };
}

export interface ProcessPaymentLinkResponse {
  success: boolean;
  message: string;
  data?: {
    payment?: {
      id: number;
      amount: number;
      patient_id: number;
      description: string;
      patient_full_name: string;
      payment_method: string;
      status: string;
    };
    appointment: {
      id: number | null;
      doctor_name: string;
      sub_care_type_name: string;
      date: string;
      start_time: string;
      payment: {
        id: number | null;
        amount: number | null;
      };
    };
    approve_url?: string | null;
  };
}

export interface PaymentLinkDetailsRequest {
  appointment_id?: string;
  payment_id?: string;
}

export interface PaymentLinkDetailsResponse {
  success: boolean;
  data: {
    appointment?: {
      id: number;
      doctor_name: string;
      sub_care_type_name: string;
      date: string;
      start_time: string;
      end_time: string;
      payment: {
        id: number;
        amount: number;
        status: string;
      };
    };
    payment?: {
      id: number;
      amount: number;
      status: string;
    };
  };
  message: string;
}

export const getPaymentLinkDetails = async (
  params: PaymentLinkDetailsRequest
): Promise<PaymentLinkDetailsResponse> => {
  const queryParams = new URLSearchParams();
  if (params.appointment_id) {
    queryParams.append('appointment_id', params.appointment_id);
  }
  if (params.payment_id) {
    queryParams.append('payment_id', params.payment_id);
  }

  const response = await axiosInstance.get<PaymentLinkDetailsResponse>(
    `${ApiRoute.Payment}?${queryParams.toString()}`
  );
  return response.data;
};

export const processPaymentLinkCardPayment = async (
  params: ProcessPaymentLinkRequest
): Promise<ProcessPaymentLinkResponse> => {
  const response = await axiosInstance.post<ProcessPaymentLinkResponse>(
    `${ApiRoute.Payment}`,
    params
  );
  return response.data;
};

export const processPaymentLinkPaypalPayment = async (
  params: ProcessPaymentLinkRequest
): Promise<ProcessPaymentLinkResponse> => {
  const response = await axiosInstance.post<ProcessPaymentLinkResponse>(
    `${ApiRoute.PayPaypalPayment}`,
    params
  );
  return response.data;
};
